/*
 * @Description: 模块编辑器组件初始化配置
 * @Date: 2023-08-20
 */

export default {
  label: '模块列表',
  type: 'moduleEditor',
  property: 'modules',
  value: [],
  child: null,
  options: {
    note: '管理模块列表，最多支持30个模块',
    max: 30
  }
} 